import { BehaviorSubject } from "rxjs";
import {
  AuthorizedPolicyDto,
  IBackofficeUserDto,
} from "../generated/api-client";

interface Indentity {
  user: IBackofficeUserDto | null;
  endpointsAllowed: AuthorizedPolicyDto[] | null;
}

const identityState = new BehaviorSubject<Indentity>({
  user: null,
  endpointsAllowed: null,
});

export const identityService = {
  get userValue() {
    return identityState.value.user;
  },
  set userValue(user: IBackofficeUserDto | null) {
    identityState.next({ ...identityState.value, user });
  },
  get endpointsAllowedValue() {
    return identityState.value.endpointsAllowed;
  },
  set endpointsAllowedValue(endpointsAllowed: AuthorizedPolicyDto[] | null) {
    identityState.next({ ...identityState.value, endpointsAllowed });
  },
  /**
   * Check if the user is allowed to call the given endpoint.
   * @param url - Exact URL (e.g. "batteries") or pattern with literal "{...}" for one path segment
   *              (e.g. "subscriptions/batteries/{...}"): only "{...}" is treated as "any segment",
   *              the check passes if any allowed endpoint matches (e.g. subscriptions/batteries/{shopSubscriptionId}).
   * @param method - HTTP method (GET, POST, PUT, DELETE, etc.)
   */
  checkEndpointsAllowed(url: string, method: string) {
    const cleanedUrl = url.startsWith("/") ? url.slice(1) : url;
    const usePattern = cleanedUrl.includes("{...}");

    const urlMatches = usePattern
      ? (() => {
          const segmentPlaceholder = "__SEGMENT__";
          const escaped = cleanedUrl
            .replace(/\{\.\.\.\}/g, segmentPlaceholder)
            .replace(/[.*+?^${}()|[\]\\]/g, "\\$&")
            .replace(
              new RegExp(segmentPlaceholder.replace(/./g, "\\$&"), "g"),
              "[^/]+"
            );
          const re = new RegExp("^" + escaped + "$");
          return (eUrl: string | null | undefined) =>
            eUrl != null && re.test(eUrl);
        })()
      : (eUrl: string | null | undefined) => eUrl === cleanedUrl;

    const r = this.endpointsAllowedValue?.some((a) =>
      a.allowedEndpoints?.some(
        (e) =>
          urlMatches(e.url) && e.methods?.some((m) => m === method)
      )
    );
    console.log(
      cleanedUrl + (usePattern ? " (pattern) " : " ") + method + "    " + r
    );
    return r;
  },
};
